module.exports = __webpack_public_path__ + "assets/img/service6.f77e4164.png";